import httpUtils from '../../utils/HttpUtils'
import session from '../../utils/Session'

class TradeOrderService {

  //查询商品订单列表
  async list(status='',pageNo = 1) {
    console.log('查询商品订单列表');
    let result = null;
    try {
      let customerId = session.getAccountToken().id;
      result = await httpUtils.post('/mall/trade/order/list', {customerId,status,pageNo})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //查询商品订单详情
  async detail(orderId) {
    console.log('查询商品订单详情');
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/order/detail', {orderId})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //取消订单
  async cancelOrder(id) {
    console.log('取消订单');
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/order/cancel', {id})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //支付订单
  // browserType 浏览器类型 1、微信浏览器 2、非微信浏览器
  async payOrder(id,browserType = '2') {
    console.log('支付订单');
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/order/pay', {id,browserType})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //生成订单
  async createOrder(cartIds = []) {
    console.log('生成订单');
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/order/create',{cartIds})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //保存订单并支付
  // browserType 浏览器类型 1、微信浏览器 2、非微信浏览器
  async saveAndPayOrder(addressId = '',cartIds = [],browserType = '') {
    console.log('保存订单并支付');
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/order/saveandpay', {addressId,cartIds,browserType})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //商城订单退款
  async refundOrder(id,reason) {
      let result = null;
      try {
          result = await httpUtils.post('/mall/trade/order/refund', {id,reason})
      } catch (error) {
          console.log('连接失败', e);
          result = {code: 1, msg: '连接失败'};
      }
      return result
  }
}
export default new TradeOrderService()
